import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { onChangeHandler } from "npm-solvitize/utils/Common";
import { apiRequest } from "../core/utils";
import { loginApi } from "../core/api_endpoints";
import logo from "../assets/images/logo/logo_shweet.png";
import { VERSION } from "../core/config";

function SignIn() {
  const navigate = useNavigate();

  const { login } = useAuth();

  const defaultData = {
    username: "",
    password: "",
  };
  const [data, setData] = useState(defaultData);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    // e.preventDefault();
    let username = data.username;
    let password = data.password;
    // const username = "demo";
    // const token = "abc123";
    setLoading(true);
    let response = await apiRequest(`${loginApi}`, "POST", {
      username: username,
      password: password,
      keyword: "admin_login",
    });
    console.log("Login response", response);
    if (response.status) {
      let response_data = response.data;
      console.log("Response data", response_data);
      let user_token = response_data.token;
      let user_name = response_data.user_data.username;
      login(user_name, user_token);
      setLoading(false);
      navigate("/");
    } else {
      alert(response.message || "Login error", "error", 5000);
      setLoading(false);
    }
  };

  const onChange = (e) => {
    onChangeHandler(e, data, setData);
  };

  return (
    <div
      data-card-height="cover"
      className="card bg-white"
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* <div
        className="card card-style bg-25"
        // style={{backgroundImage: 'uri(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVke6JuMVSib2oSuZ8RzD6ven3T4EiVO5V1Q&s)', height: 200}}
        style={{
          backgroundImage:
            "url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVke6JuMVSib2oSuZ8RzD6ven3T4EiVO5V1Q&s')",
          height: "200px",
          // width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "8px",
        }}
        // background-image: url(../images/pictures/25.jpg)
        data-card-height={200}
      >
        <div className="card-center">
          <p className="text-center mb-2">
            <i className="fa fa-check-circle color-green-dark fa-4x" />
          </p>
          <h1 className="color-white text-center mb-0">Font Awesome 5</h1>
          <p className="color-white text-center opacity-60 mt-n1 mb-3">
            Icons work like a charm here as well!.
          </p>
        </div>
        <div className="card-overlay bg-black opacity-80" />
      </div> */}

      {/* <div className="card-top notch-clear">
        <div className="d-flex">
          <a href="#" data-back-button className="me-auto icon icon-m">
            <i className="font-14 fa fa-arrow-left color-theme" />
          </a>
          <a
            href="#"
            data-toggle-theme
            className="show-on-theme-light ms-auto icon icon-m"
          >
            <i className="font-12 fa fa-moon color-theme" />
          </a>
          <a
            href="#"
            data-toggle-theme
            className="show-on-theme-dark ms-auto icon icon-m"
          >
            <i className="font-12 fa fa-lightbulb color-yellow-dark" />
          </a>
        </div> 
      </div> */}
      <div className="card-center">
        <div className="ps-5 pe-5">
          {/* logo */}
          <img
            src={logo}
            alt="sHweet"
            className="d-block mx-auto"
            style={{
              borderRadius: "16px",
              marginBottom: "24px",
            }}
          />

          {/* <h6 className="text-center font-800 font-40 mb-1">Log In</h6> */}
          <p className="xcolor-highlight text-center font-12">
            Let's get you logged in
          </p>
          <div className="input-style no-borders has-icon validate-field">
            <i className="fa fa-id-card" />
            <input
              type="name"
              className="form-control validate-name"
              id="form1a"
              placeholder="Franchise Code"
              name={"username"}
              value={data.username}
              onChange={onChange}
            />
            <label htmlFor="form1a" className="color-blue-dark font-10 mt-1">
              Name
            </label>
            <i className="fa fa-times disabled invalid color-red-dark" />
            <i className="fa fa-check disabled valid color-green-dark" />
            <em>(required)</em>
          </div>
          <div className="input-style no-borders has-icon validate-field mt-4">
            <i className="fa fa-lock" />
            <input
              type="password"
              className="form-control validate-password"
              id="form3a"
              placeholder="Password"
              name={"password"}
              value={data.password}
              onChange={onChange}
            />
            <label htmlFor="form3a" className="color-blue-dark font-10 mt-1">
              Password
            </label>
            <i className="fa fa-times disabled invalid color-red-dark" />
            <i className="fa fa-check disabled valid color-green-dark" />
            <em>(required)</em>
          </div>
          {/* <div className="d-flex mt-4 mb-4">
            <div className="w-50 font-11 pb-2 text-start">
              <a href="page-signup-2.html">Create Account</a>
            </div>
            <div className="w-50 font-11 pb-2 text-end">
              <a href="page-forgot-2.html">Forgot Credentials</a>
            </div>
          </div> */}
          <a
            href="#"
            className="back-button btn btn-full btn-m shadow-large rounded-sm text-uppercase font-700 bg-black color-white"
            style={{
              opacity: loading ? 0.7 : 1,
              pointerEvents: loading ? "none" : "auto",
            }}
            onClick={() => !loading && handleLogin()}
          >
            {loading ? (
              <>
                <i className="fa fa-spinner fa-spin me-2"></i>
                LOGGING IN...
              </>
            ) : (
              "LOGIN"
            )}
          </a>
          <div className="divider mt-4" />
          <div className="text-center">Version: {VERSION}</div>
          {/* <a href="#" className="btn btn-icon btn-m btn-full shadow-l rounded-sm bg-facebook text-uppercase font-700 text-start" style={{}}><i className="fab fa-facebook-f text-center bg-transparent" />Sign in with Facebook</a>
                    <a href="#" className="btn btn-icon btn-m btn-full shadow-l rounded-sm bg-twitter text-uppercase font-700 text-start mt-2 " style={{}}><i className="fab fa-twitter text-center bg-transparent" />Sign in with Twitter</a> */}
        </div>
      </div>
    </div>
  );
}

export default SignIn;
